import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { API } from 'utils';

import { cache } from '../cache';
import { errorLink } from '../links/errorLink';

const { createUploadLink } = require("apollo-upload-client");

const httpLink = createUploadLink({
	uri: `${API.LTAAdminClient.url}`,
});

const adminClientLink = errorLink('LTAAdminClient').concat(httpLink);

export const adminClient = new ApolloClient<NormalizedCacheObject>({
	link: adminClientLink,
	cache,
	queryDeduplication: false,
	connectToDevTools: true,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'cache-and-network',
		},
		query: {
			fetchPolicy: 'network-only',
		},
	},
});

export default adminClient;
